import { AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, Box, Button, Center, Flex, Heading, useColorModeValue } from "@chakra-ui/react";
import Logo from "../../../assets/img/logo/Byrd_Logo.png";
import { EmailForm } from "./components/EmailForm";
import { useRecover } from "./hooks/useRecover";
import { CodeForm } from "./components/CodeForm";
import { PasswordForm } from "./components/PasswordForm";

export default function RecoverPass() {

  const textColor = useColorModeValue("navy.700", "white");

  const {
    state,
    changeEmailInput,
    emailValidate,
    sendEmail,
    changeCodeInput,
    codeValidate,
    sendCode,
    backward,
    changeInput,
    displayInputError,
    savePass,
    closeError,
    cancelRef
  } = useRecover();

  return (
    <Center>
      <Flex
        maxW={{ base: "100%", md: "max-content" }}
        w="100%"
        mx={{ base: "auto", lg: "0px" }}
        me="auto"
        h="100%"
        alignItems="start"
        justifyContent="center"
        mb={{ base: "30px", md: "60px" }}
        px={{ base: "25px", md: "0px" }}
        mt={{ base: "0px", md: "8vh" }}
        flexDirection="column"
      >
        <img
          src={Logo}
          alt={"Broders logo"}
          style={{ margin: "0px auto", width: 200 }}
        />
        <Box me="auto">
          <Heading color={textColor} fontSize="36px" mb="10px" mt="20px">
            Recuperar Senha
          </Heading>

          {state.step === "EMAIL" && (
            <EmailForm
              state={state}
              changeEmailInput={changeEmailInput}
              emailValidate={emailValidate}
              sendEmail={sendEmail}
            />
          )}

          {state.step === "CODE" && (
            <CodeForm
              state={state}
              changeCodeInput={changeCodeInput}
              codeValidate={codeValidate}
              sendCode={sendCode}
              backward={backward}
            />
          )}

          {state.step === "PASSWORD" && (
            <PasswordForm
              state={state}
              changeInput={changeInput}
              displayInputError={displayInputError}
              savePass={savePass}
              backward={backward}
            />
          )}

          <AlertDialog
            isOpen={state.error}
            leastDestructiveRef={cancelRef}
            onClose={closeError}
            isCentered
            motionPreset="slideInBottom"
          >
            <AlertDialogOverlay>
              <AlertDialogContent>
                <AlertDialogHeader fontSize="lg" fontWeight="bold">
                  {state.errorTitle}
                </AlertDialogHeader>

                <AlertDialogBody>{state.errorMsg}</AlertDialogBody>

                <AlertDialogFooter>
                  <Button
                    ref={cancelRef}
                    onClick={closeError}
                    colorScheme={"blue"}
                  >
                    OK
                  </Button>
                </AlertDialogFooter>
              </AlertDialogContent>
            </AlertDialogOverlay>
          </AlertDialog>
        </Box>
      </Flex>
    </Center>
  );
}
